// extracted by mini-css-extract-plugin
module.exports = {"scrollTrack":"BaseScrollbars_scrollTrack__GQuiW","scrollThumb":"BaseScrollbars_scrollThumb__Vnj68"};